/* src/app/views/information/information.component.scss */
.information-page {
  width: 100%;
  padding: 22px 0 0;
  box-sizing: border-box;
}
.information-shell {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 28px 30px;
  border: 1px solid #d8e0eb;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 12px 28px rgba(16, 43, 78, 0.07);
  display: grid;
  grid-template-columns: minmax(340px, 1fr) minmax(380px, 1.2fr);
  gap: 28px;
  align-items: center;
  color: #102b4e;
}
.information-copy {
  max-width: 620px;
}
.information-title {
  margin: 0 0 18px;
  font-size: clamp(30px, 2.7vw, 44px);
  line-height: 1.1;
  font-weight: 620;
  letter-spacing: -0.02em;
  color: #102b4e;
}
.information-lead {
  margin: 0 0 14px;
  font-size: clamp(17px, 1.35vw, 22px);
  line-height: 1.45;
  color: #17345f;
}
.information-list {
  margin: 0;
  padding-left: 22px;
  display: grid;
  gap: 8px;
  color: #17345f;
  font-size: clamp(16px, 1.15vw, 20px);
  line-height: 1.45;
}
.information-actions {
  margin-top: 26px;
}
.action-button {
  width: 100%;
  max-width: 260px;
  height: 48px;
}
.system-guide-button {
  min-width: 230px !important;
  height: 48px !important;
  min-height: 48px !important;
  padding: 0 18px !important;
  border-radius: 12px !important;
}
.information-footer {
  margin: 26px 0 0;
  font-size: clamp(15px, 1vw, 17px);
  line-height: 1.5;
  color: #17345f;
}
.information-link {
  color: #005fad;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.information-link:hover {
  color: #0077d6;
}
.information-visual {
  margin: 0;
  padding-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.information-image {
  width: min(100%, 760px);
  height: auto;
  display: block;
  object-fit: contain;
}
.loading {
  position: absolute;
  top: 35%;
  left: 50%;
  font-size: 60px;
  font-weight: bold;
}
@media only screen and (max-width: 1100px) {
  .information-page {
    padding: 18px 0 0;
  }
  .information-shell {
    padding: 24px 20px;
    grid-template-columns: 1fr;
    gap: 24px;
    align-items: start;
  }
  .information-copy {
    max-width: 100%;
  }
  .information-visual {
    order: 2;
    padding-bottom: 6px;
  }
  .information-image {
    width: min(100%, 680px);
  }
}
@media only screen and (max-width: 700px) {
  .information-page {
    padding: 14px 0 0;
  }
  .information-shell {
    padding: 18px 14px;
    border-radius: 8px;
    gap: 18px;
  }
  .information-title {
    margin-bottom: 14px;
    font-size: clamp(24px, 7vw, 34px);
  }
  .information-lead {
    margin-bottom: 10px;
  }
  .information-list {
    gap: 7px;
    padding-left: 18px;
  }
  .information-actions {
    margin-top: 20px;
  }
  .action-button,
  .system-guide-button {
    width: 100%;
    max-width: 100%;
  }
  .information-footer {
    margin-top: 20px;
  }
}
/*# sourceMappingURL=information.component-3G6VMR4K.css.map */
